/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import { Text, View } from 'react-native';

import styles from '../../styles';

class PublisherStatistic extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherStatistic';
  }

  render() {
    return (
      <View
        style={styles.view.headless}
      >
        <Text>
          PublisherStatistics
        </Text>
      </View>
    );
  }
}

export default PublisherStatistic;
